import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { api } from 'app/api'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { GET_ALLOWANCES_LIST, convertParams, convertResult } from 'app/common/api/requests/food/allowances/get'


type Allowances = Array<ItemType>

class AllowancesFilterDataBox extends DataBox<Allowances> { }

export const defaultAllowances: Allowances = []
export const allowancesFilter = createDataBox('allowancesFilter', defaultAllowances, AllowancesFilterDataBox)


const convertFromExtended = (allowances: Array<string>): Allowances => {
  return allowances.map((allowance) => {
    return ({ id: allowance, title: allowance })
  })
}


export const defaultAllowancesDataReceiver = async () => {
  const res = await api.request(GET_ALLOWANCES_LIST, {
    error: 'Не удалось получить список льгот',
    convertions: {
      convertParams,
      convertResult,
    },
  })
  return res ? convertFromExtended(res) : []
}

export const defaultAllowancesSelection: Array<string> = []
export const allowancesFilterSelection = createDataBoxDefault<Array<string>>('allowancesFilterSelection', defaultAllowancesSelection)
